module.exports = __webpack_public_path__ + "/images/shop/icon/loading_orange--autoteile24.svg";